import i18next from 'i18next';

export const getTooltipTexts = () => ({
  INGREDIENT_COST_AUTOMATIC_CALCULATION_SUCCESS: i18next.t(
    'ADMIN.INGREDIENTS.INGREDIENT_COST_AUTOMATIC_CALCULATION_SUCCESS',
  ),
  INGREDIENT_COST_AUTOMATIC_CALCULATION_FAILURE: i18next.t(
    'ADMIN.INGREDIENTS.INGREDIENT_COST_AUTOMATIC_CALCULATION_FAILURE',
  ),
});
